var GlobalFooter = (function () {
  

  Utility.log('GlobalFooter.js loaded');

  var $elements = $.noop;

  function init() {
    $elements = $('li', '.acr-footer');
    setOnResize();
    resize();
    addPadding();
  }

  function addPadding() {
    $('.acr-footer.secondary li').not(':has(a)').css('padding-left', '1.5rem');
  }

  function setOnResize() {
    window.addEventListener('resize', resize);
  }

  function resize() {
    var width = window.innerWidth;

    if (width < Constants.breakpoints.lg) {
      setTimeout(noBorder, 100);
    }
  }

  function noBorder() {
    var $prev = $elements.eq(0);

    $elements.removeClass('no-border');

    $elements.slice(1).each(function () {
      if ($(this).position().top > $prev.position().top) {
        $(this).addClass('no-border');
      }
      $prev = $(this);
    });
  }

  return {
    init: init,
  };
}());
